import React from 'react';

import cs from 'classnames';

import {GuestFileAccessLink} from 'app/mediaaccess/components/FileAccess';
import {
  StepAttachmentsTitle,
  StyledStepContentSeparatorDiv,
} from 'app/procedures/components/structures';
import {StyledStepAttachedLi} from 'app/procedures/styles';
import {useAccountSettingsState} from 'app/settings/api';

import type {AttachedFileWithDiff} from 'app/general/types';

interface Props {
  files: Array<AttachedFileWithDiff>;
}

export function ProcedureStepFiles({files}: Props) {
  const {MEDIA_URL_PROTECTED} = useAccountSettingsState().data!;

  return (
    <StyledStepContentSeparatorDiv className="files">
      <StepAttachmentsTitle />
      <ul className="list-group">
        {files.map((file) => (
          <StyledStepAttachedLi
            key={file.file_ref}
            className={cs(file.changedState, 'list-group-item border-0')}
          >
            <GuestFileAccessLink
              MEDIA_URL_PROTECTED={MEDIA_URL_PROTECTED}
              file_ref={file.file_ref}
              file_name={file.file_name}
            />
          </StyledStepAttachedLi>
        ))}
      </ul>
    </StyledStepContentSeparatorDiv>
  );
}
